import { API } from '../../api';
import { COLLATE_DATA_MANAGER, MARRIAGE_DATA_MANAGER } from '../../data';

export default {
    namespaced: true,
    state: {
        marriageType: 2, // 1:个人婚恋 2:两人合婚
        showBirthday: false,
        showBirthdayType: 'first', // first:第一个人 second:第二个人 lover:恋人
        showLocation: false,
        showLocationType: 'first', // first:第一个人 second:第二个人 lover:恋人
        chooseItemType: 'first', // first:第一个人 second:第二个人 lover:恋人
        curPage: 0,
        gotRecordData: false,
        noRecordData: false,
        recordTotalData: {}, 
        recordListData: [],
        searchListData: [],
        marriageFormData: {
            loverName: '', loverGender: 0, loverBirthday: 0, loverBirthtime: [], loverLocation: '', loverLocationStr: [],
            firstName: '', firstGender: 0, firstBirthday: 0, firstBirthtime: [], firstLocation: '', firstLocationStr: [],
            secondName: '', secondGender: 1, secondBirthday: 0, secondBirthtime: [], secondLocation: '', secondLocationStr: [],
        },
        marriageFavorableInfoData: {},
        marriageShareCode: '',
        marriageData: {},
        marriageBaseDataOne: null,
        marriageBaseDataTwo: null,
        marriageOneInfoData: {},
        marriageMaleInfoData: {},
        marriageFemaleInfoData: {},
        marriageMergeInfoData: {},
    },
    mutations: {
    },
    actions: {
        confirmBirthday({ state }, inputData) {
            state.showBirthday = false;
            let birthTime = MARRIAGE_DATA_MANAGER.getSelectedBirthdayStringByData(inputData);
            let birthday = MARRIAGE_DATA_MANAGER.getPaiPanParamsBirthday(inputData);
            console.log('confirmBirthday', inputData, birthTime, birthday);
            if(state.marriageType == 1) {
                state.marriageFormData.loverBirthtime = birthTime;
                state.marriageFormData.loverBirthday = birthday;
            } else if(state.marriageType == 2) {
                if(state.showBirthdayType == 'first') {
                    state.marriageFormData.firstBirthtime = birthTime;
                    state.marriageFormData.firstBirthday = birthday;
                }else if(state.showBirthdayType == 'second') {
                    state.marriageFormData.secondBirthtime = birthTime;
                    state.marriageFormData.secondBirthday = birthday;
                }
            }
        },
        confirmArea({state}, areaArr) {
            console.log('confirmArea-----', state.marriageType, state.showLocationType, areaArr);
            state.showLocation = false;
            let areaStrArr = areaArr[0].name == '不选择' ? '' : COLLATE_DATA_MANAGER.getSelectedAreaStringByArr(areaArr);
            let location = COLLATE_DATA_MANAGER.getPaiPanParamsLocation(areaArr);
            switch(state.showLocationType) {
                case 'first':
                    state.marriageFormData.firstLocationStr = areaStrArr;
                    state.marriageFormData.firstLocation = location;
                    break;
                case 'second':
                    state.marriageFormData.secondLocationStr = areaStrArr;
                    state.marriageFormData.secondLocation = location;
                    break;
                case 'lover':
                    state.marriageFormData.loverLocationStr = areaStrArr;
                    state.marriageFormData.loverLocation = location;
                    break;
                default:
                    break;
            }
            console.log('confirmArea-----', areaArr, areaStrArr, location);
        },
        confirmChooseItem({state}, itemData) {
            console.log('confirmChooseItem---', itemData);
            switch(state.chooseItemType){
                case 'first':
                    state.marriageFormData.firstName = itemData.f_name;
                    state.marriageFormData.firstBirthday = itemData.birthday;
                    state.marriageFormData.firstBirthtime = COLLATE_DATA_MANAGER.getSelectedBirthdayStringByDetailData(itemData);
                    state.marriageFormData.firstLocation = itemData.location;
                    state.marriageFormData.firstLocationStr = COLLATE_DATA_MANAGER.getSelectedAreaStringByString(itemData.location);
                    break;
                case 'second':
                    state.marriageFormData.secondName = itemData.f_name;
                    state.marriageFormData.secondBirthday = itemData.birthday;
                    state.marriageFormData.secondBirthtime = COLLATE_DATA_MANAGER.getSelectedBirthdayStringByDetailData(itemData);
                    state.marriageFormData.secondLocation = itemData.location;
                    state.marriageFormData.secondLocationStr = COLLATE_DATA_MANAGER.getSelectedAreaStringByString(itemData.location);
                    break;
                case 'lover':
                    state.marriageFormData.loverName = itemData.f_name;
                    state.marriageFormData.loverGender = itemData.sex;
                    state.marriageFormData.loverBirthday = itemData.birthday;
                    state.marriageFormData.loverBirthtime = COLLATE_DATA_MANAGER.getSelectedBirthdayStringByDetailData(itemData);
                    state.marriageFormData.loverLocation = itemData.location;
                    state.marriageFormData.loverLocationStr = COLLATE_DATA_MANAGER.getSelectedAreaStringByString(itemData.location);
                    break;
                default:
                    break;
            }
        },
        // 添加合婚记录
        addMarriageRecord({ dispatch, state }, params) {

            if(state.marriageType != 1 && state.marriageType != 2){
                AppFate.$toast('请选择合婚类型');
                return;
            }
            let newParams = {f_type: state.marriageType};
            if(state.marriageType == 1) {
                newParams = Object.assign(newParams, {
                    f_first_bday: state.marriageFormData.loverBirthday, f_first_gender: state.marriageFormData.loverGender, f_first_name: state.marriageFormData.loverName, f_first_location: state.marriageFormData.loverLocation, 
                });
            }else if(state.marriageType == 2) {
                newParams = Object.assign(newParams, {
                    f_first_bday: state.marriageFormData.firstBirthday, f_first_gender: state.marriageFormData.firstGender, f_first_name: state.marriageFormData.firstName, f_first_location: state.marriageFormData.firstLocation,
                    f_second_bday: state.marriageFormData.secondBirthday, f_second_gender: state.marriageFormData.secondGender, f_second_name: state.marriageFormData.secondName, f_second_location: state.marriageFormData.secondLocation,
                });
            }
            console.log('addMarriageRecord-----', state.marriageType, state.marriageFormData, newParams);

            API.addMarriage(newParams, function(data) {
                console.log('添加合婚记录成功:::::::', data);
                // 添加到列表顶部
                let rData = Object.assign(data, newParams);
                state.recordListData = [rData].concat(state.recordListData);
                // 清除数据
                dispatch('resetFormData');
                state.marriageData = Object.assign({isNew: true}, data);
                state.marriageShareCode = data.share_code;
                if(data.info.length == 1) {
                    state.marriageBaseDataOne = Object.assign({}, data.info[0]);
                }else if(data.info.length == 2) {
                    state.marriageBaseDataOne = Object.assign({}, data.info[0]);
                    state.marriageBaseDataTwo = Object.assign({}, data.info[1]);
                }   
                if(params.sucCb && typeof params.sucCb == 'function') {
                    params.sucCb();
                }
            });

        },
        // 设置验证并获取BaseData
        setMarriageVerifyData({ state }, params) {
            console.log('setMarriageVerifyData-----', state.marriageType, state.marriageData);
            // 设置验证
            API.setMarriageVerify({
                id: state.marriageData.id
            }, ()=> {
                console.log('设置验证成功:::::::');
                // 更新列表数据:verify状态
                state.recordListData.forEach((item, index) => {
                    if(item.id == state.marriageData.id) {
                        item.f_verify = 1;
                    }
                });
                if(state.marriageBaseDataOne) {
                    // 已经获取过了
                    if(params.sucCb && typeof params.sucCb == 'function') {
                        params.sucCb();
                    }
                    return;
                }
                // 获取BaseData
                API.getMarriageBaseInfo({
                    id: state.marriageData.id
                }, (data) => {
                    console.log('获取合婚BaseData成功::::::::', data);
                    if(data.info.length == 1) {
                        state.marriageBaseDataOne = Object.assign({}, data.info[0]);
                    }else if(data.info.length == 2) {
                        state.marriageBaseDataOne = Object.assign({}, data.info[0]);
                        state.marriageBaseDataTwo = Object.assign({}, data.info[1]);
                    }   
                    if(params.sucCb && typeof params.sucCb == 'function') {
                        params.sucCb();
                    }
                })
            })
        },
        // 获取合婚列表
        initRecordList({ state }, params) {
            var tempArr = [];
            // 轮询机制：遍历数据取到最大f_time值再次请求，直到获取到的list为空
            function getData() {
                return new Promise((resolve, reject) => {
                    API.getMarriageList({
                        "id": state.recordMinId
                    }, function (data) {
                        console.log('获取数据成功------', data);
                        state.recordListData = data.info;
                        state.recordTotalData = data.total;
                        state.curPage = state.curPage+1;

                        // 记录列表数据轮询拉取
                        if(state.curPage >= state.recordTotalData.totalpage) {
                            state.gotRecordData = true;
                            state.noRecordData = state.recordListData.length > 0 ? false : true;
                            console.log("已经拉取完了", state.recordListData.length);
                            if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                                params.sucCb();
                            }
                            resolve();
                        }
                    });
                }).catch((err) => {
                    console.error("拉取数据失败", err);
                });
            }
            // 轮询
            function start() {
                console.log('start------', state.gotRecordData);
                async function timeFn () {
                    if(state.gotRecordData) {
                        return;
                    }
                    await getData().then(function() {
                        setTimeout(timeFn, 20)
                    });
                }
                timeFn()
            }
            start()
        },
        confirmSearchMarriage({ state }, sWord) {
            state.searchListData = state.recordListData.filter((item) => {
                return item.f_first_name.indexOf(sWord) != -1 || (item.f_type == 2 && item.f_second_name.indexOf(sWord) != -1);
            });
            console.log('confirmSearchMarriage------', sWord, state.searchListData);
        },
        // 清除搜索数据
        clearSearchMarriage({ state }) {
            state.searchListData = [];
        },
        // 获取合婚的五行信息
        getMarriageFavorableInfoById({ dispatch, state }, params) {

            API.getMarriageFavorableElement({
                id: params.rData.id
            }, (data) => {
                console.log('获取合婚的五行信息成功::::::::', data);
                state.marriageData = Object.assign(state.marriageData, data);
                state.marriageFavorableInfoData = MARRIAGE_DATA_MANAGER.getFavorableInfoDataByData(data);
                if(!state.marriageData.isNew && params.rData.f_pay !== 0) {
                    dispatch('getMarriageInfoById', params);
                }else {
                    if(params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                }
            })
        },
        // 获取合婚信息
        getMarriageInfoById({ state }, params) {
            console.log('getMarriageInfo------', params);
            API.getMarriageInfo({
                id: params.rData.id
            }, (data) => {
                console.log('获取合婚信息成功::::::::', data);
                state.marriageShareCode = data.share_code;
                if(data.f_type == 1) {
                    // 处理个人合婚数据
                    state.marriageData.is_pay = data.is_pay; // 更新支付状态
                    state.marriageOneInfoData = Object.assign({}, data.show);
                }else if(data.f_type == 2) {
                    // 处理二人合婚数据
                    state.marriageData = Object.assign({}, data);
                    state.marriageMaleInfoData = Object.assign({}, data.show.male);
                    state.marriageFemaleInfoData = Object.assign({}, data.show.female);
                    state.marriageMergeInfoData = Object.assign({}, data.show.mergeInfo);
                }
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            })
        },
        getMarriageInfoByShareCode({ state }, params) {
            API.getMarriageInfoByCode({
                code: params.mCode
            }, (data) => {
                console.log('根据shareCode获取合婚信息成功::::::::', data);
                state.marriageShareCode = data.share_code;
                state.marriageFavorableInfoData = MARRIAGE_DATA_MANAGER.getFavorableInfoDataByData(data.favorableElement);
                if(data.marriage.f_type == 1) {
                    // 处理个人合婚数据
                    state.marriageData = Object.assign({}, data.marriage);
                    state.marriageOneInfoData = Object.assign({}, data.marriage.show);
                }else if(data.marriage.f_type == 2) {
                    // 处理二人合婚数据
                    state.marriageData = Object.assign({}, data.marriage);
                    state.marriageMaleInfoData = Object.assign({}, data.marriage.show.male);
                    state.marriageFemaleInfoData = Object.assign({}, data.marriage.show.female);
                    state.marriageMergeInfoData = Object.assign({}, data.marriage.show.mergeInfo);
                }
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            })

        },
        // 免费解锁合婚报告
        vipUnlockMarriageReport({ state }, params) {
            console.log('vipUnlockMarriageReport------', params);
            API.vipUnlockMarriage({
                id: state.marriageData.id
            }, (data) => {
                console.log('免费解锁合婚报告成功::::::::', data);
                state.marriageData.is_pay = 1;
                // 更新列表数据:pay状态
                state.recordListData.forEach((item, index) => {
                    if(item.id == state.marriageData.id) {
                        item.f_pay = 1;
                    }
                });
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, () => {
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        resetFormData({ state }) {
            state.marriageFormData = {
                firstName: '', firstGender: 0, firstBirthday: 0, firstBirthtime: [], firstLocation: '', firstLocationStr: [],
                secondName: '', secondGender: 1, secondBirthday: 0, secondBirthtime: [], secondLocation: '', secondLocationStr: [],
                loverName: '', loverGender: 0, loverBirthday: 0, loverBirthtime: [], loverLocation: '', loverLocationStr: [],
            };
            state.marriageData = {};
            state.marriageFavorableInfoData = {};
        },
        resetMarriageData({ state }) {
            state.marriageOneInfoData = {};
            state.marriageBaseDataOne = null;
            state.marriageBaseDataTwo = null;
            state.marriageMaleInfoData = {};
            state.marriageFemaleInfoData = {};
            state.marriageMergeInfoData = {};
        }
    }
}